export interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}

export type ExperimentMap = Record<string, ExperimentData>;
export type ExperimentData = Record<string, unknown>;

export enum IncreaseAdsInHomepageExperimentValues {
    control = 'control',
    moreAds = 'more-ads',
}

export const IncreaseAdsInHomepageExperiment: Experiment<
    typeof IncreaseAdsInHomepageExperimentValues
> = {
    name: 'increase-ads-in-homepage',
    paramName: 'ad-quantity',
    values: IncreaseAdsInHomepageExperimentValues,
};

export enum SearchThirdAdValues {
    control = 'control',
    increaseAds = 'variant',
}

export const SearchThirdAd: Experiment<typeof SearchThirdAdValues> = {
    name: 'web_search_third_ad',
    paramName: 'variant',
    values: SearchThirdAdValues,
};

export enum SearchEventCardSignalsVisibilityExperimentValues {
    control = 'control',
    reduced = 'reduced',
}

export const SearchEventCardSignalsVisibilityExperiment: Experiment<
    typeof SearchEventCardSignalsVisibilityExperimentValues
> = {
    name: 'search-event-card-signals-visibility',
    paramName: 'signals_visibility',
    values: SearchEventCardSignalsVisibilityExperimentValues,
};

export enum SearchEventCardClickBehaviourExperimentValues {
    control = 'control',
    fullClick = 'full_click',
    // "Call to action"
    cta = 'cta',
}

export const SearchEventCardClickBehaviourExperiment: Experiment<
    typeof SearchEventCardClickBehaviourExperimentValues
> = {
    name: 'search_event_card_click_behavior',
    paramName: 'click_behavior',
    values: SearchEventCardClickBehaviourExperimentValues,
};

export const HomepageSeasonalCarouselValues = {
    control: 'hide',
    test: 'show',
};

export const HomepageSeasonalCarouselExperiment: Experiment<
    typeof HomepageSeasonalCarouselValues
> = {
    name: 'mardi_gras_new_orleans',
    paramName: 'mardi_gras_carousel',
    values: HomepageSeasonalCarouselValues,
};

export const HomepagePaidEventsCarouselExperiment: Experiment<
    typeof HomepageSeasonalCarouselValues
> = {
    name: 'homepage_paid_events_bucket_carousel_v2',
    paramName: 'paid_events_carousel',
    values: HomepageSeasonalCarouselValues,
};

export const DatingInNightlifeValues = {
    control: 'hide',
    test: 'show',
};

export const DatingInNightlifeExperiment: Experiment<
    typeof DatingInNightlifeValues
> = {
    name: 'dating_carousel_on_homepage',
    paramName: 'dating_tab',
    values: DatingInNightlifeValues,
};

export const DatingInHomepageValues = {
    control: 'hide',
    test: 'show',
};

export const DatingInHomepageExperiment: Experiment<
    typeof DatingInHomepageValues
> = {
    name: 'dating_carousel_on_homepage_v2',
    paramName: 'dating_carousel',
    values: DatingInHomepageValues,
};

export const TrendingTagEventsValues = {
    control: 'hide',
    test: 'show',
};

export const TrendingTagEventsExperiment: Experiment<
    typeof TrendingTagEventsValues
> = {
    name: 'trending_tag_events_v2',
    paramName: 'trending_events',
    values: DatingInHomepageValues,
};

export const SearchDesktopMapValues = {
    control: 'show',
    variant: 'hide',
};

export const SearchDesktopMapExperiment: Experiment<
    typeof SearchDesktopMapValues
> = {
    name: 'removing_map_experiment',
    paramName: 'map',
    values: SearchDesktopMapValues,
};

export enum DisplayAdFromRecentViewsExperimentValues {
    control = 'control',
    recentViews = 'user_interactions_viewed_inperson',
}

export const DisplayAdFromRecentViewsExperiment: Experiment<
    typeof DisplayAdFromRecentViewsExperimentValues
> = {
    name: 'homepage-for-you-display-ad-from-recent-views',
    paramName: 'bucket-name',
    values: DisplayAdFromRecentViewsExperimentValues,
};
